export const versions = {
  version: "0.1.66",
  revision: "3a0819d",
  branch: "feature/requested_adaptations",
  gitInfo: {
    dirty: false,
    raw: "v0.1.66-13-g3a0819d",
    hash: "g3a0819d",
    distance: 13,
    tag: "v0.1.66",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v0.1.66",
      major: 0,
      minor: 1,
      patch: 66,
      prerelease: [],
      build: [],
      version: "0.1.66",
    },
    suffix: "13-g3a0819d",
    semverString: "0.1.66+13.g3a0819d",
  },
};
